import React from "react";
import { InfoBlockStatus } from "o4a-react";
import {
  DeleteConfirmationPanel,
  DeleteConfirmationPanelProps,
} from "../DeleteConfirmationPanel/DeleteConfirmationPanel";
import * as Messages from "../../codegen/Messages";
import { DeleteExaInfraResourcesList } from "../DeleteExaInfraResourcesList/DeleteExaInfraResourcesList";

export interface ExaInfraDeletePanelProps extends
Pick<DeleteConfirmationPanelProps, "componentRef" | "onClose" | "onSubmit" | "targetId"> {
  location: string;
  exaInfraId: string;
}

export const ExaInfraDeletePanel = ({
  exaInfraId,
  location,
  onSubmit,
  targetId,
  componentRef,
  onClose,
}: ExaInfraDeletePanelProps): JSX.Element => {
  const [isDeleteLoading, setIsDeleteLoading] = React.useState(true);

  return (
    <DeleteConfirmationPanel
      componentRef={componentRef}
      targetId={targetId}
      title={Messages.labels.deleteExaInfra()}
      description={Messages.createNewPanels.deleteExaInfra.description()}
      onSubmit={onSubmit}
      onClose={onClose}
      infoBlock={{
        message: Messages.createNewPanels.deleteExaInfra.warningInfoBlock(),
        type: InfoBlockStatus.WARNING,
      }}
      isLoading={isDeleteLoading}
    >
      <DeleteExaInfraResourcesList
        exaInfraId={exaInfraId}
        location={location}
        setIsLoading={setIsDeleteLoading}
      />
    </DeleteConfirmationPanel>
  );
};
